import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderGuideActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM13 17.38C13 17.73 12.72 18 12.38 18H11.63C11.28 18 11.01 17.72 11.01 17.38V16.63C11.01 16.28 11.29 16.01 11.63 16.01H12.38C12.73 16.01 13 16.29 13 16.63V17.38ZM13.46 12.79C13.19 12.87 13 13.1 13 13.38V14C13 14.28 12.78 14.5 12.5 14.5H11.5C11.22 14.5 11 14.28 11 14V13.38C11 12.23 11.77 11.21 12.87 10.88C13.21 10.78 14 10.47 14 9.7C14 8.68 13.66 8 12 8C11.15 8 10.18 8.19 10.02 9.59C9.99 9.83 9.77 10 9.53 10H8.53C8.23 10 8 9.73 8.03 9.43C8.25 7.3 9.73 6 12 6C14.54 6 16 7.35 16 9.7C16 11.13 15.03 12.31 13.46 12.79Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderGuideActiveIcon.displayName = 'HeaderGuideActiveIcon';
